module.exports = __webpack_public_path__ + "static/media/ic_help.5ee36599.svg";